import { alpha, Box, Typography, useTheme } from "@mui/material";
import type { Control } from "react-hook-form";
import { useWatch } from "react-hook-form";

import {
	CommissionDistributionResource,
	useCommissionDistributionResource,
} from "CommissionDistribution/Translations/CommissionDistributionResource";
import type { CommissionDistributionFormValues } from "CommissionDistribution/Utils/commissionDistributionSchema";
import { FormCheckbox } from "Forms/Components/FormCheckbox";

type Props = {
	control: Control<CommissionDistributionFormValues>;
};

export const CommissionDistributionConfirmSection = ({ control }: Props) => {
	const { t } = useCommissionDistributionResource();
	const R = CommissionDistributionResource;
	const theme = useTheme();
	const isConfirmed = useWatch({ control, name: "isConfirmed" });

	const accent = isConfirmed
		? theme.palette.success.main
		: theme.palette.warning.main;

	return (
		<Box
			sx={{
				border: "2px solid",
				borderColor: accent,
				borderLeftWidth: 6,
				borderRadius: 1,
				p: 2,
				bgcolor: alpha(accent, 0.08),
				boxShadow: 2,
				transition: "all 0.2s",
			}}
		>
			<FormCheckbox
				color="primary"
				name="isConfirmed"
				control={control}
				sx={{ alignItems: "flex-start", mr: 0 }}
				label={
					<Box>
						<Typography variant="subtitle1" fontWeight={800}>
							{t(R.Dialog.ConfirmCheckboxTitle)}
						</Typography>
						<Typography variant="body2" color="text.secondary">
							{t(R.Dialog.ConfirmCheckboxBody)}
						</Typography>
					</Box>
				}
			/>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: "block", mt: 1, pl: 2.5, fontStyle: "italic" }}
			>
				{t(R.Dialog.ConfirmNote)}
			</Typography>
		</Box>
	);
};
